import { render } from "./Cbdwkh.vue?vue&type=template&id=062de3df"
import script from "./Cbdwkh.vue?vue&type=script&lang=js"
export * from "./Cbdwkh.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__